import { createSelector, createFeatureSelector } from '@ngrx/store';
import { UnsavedChangesState } from './unsaved-changes.reducer';

export const selectUnsavedChangesState = createFeatureSelector<UnsavedChangesState>('unsavedChanges');

export const selectHasUnsavedChanges = createSelector(
    selectUnsavedChangesState,
    (state: UnsavedChangesState) => state.hasUnsavedChanges
);
